import { render, staticRenderFns } from "./PersonnelDashboard.vue?vue&type=template&id=44e647cf&scoped=true&"
import script from "./PersonnelDashboard.vue?vue&type=script&lang=js&"
export * from "./PersonnelDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e647cf",
  null
  
)

export default component.exports